<div class="wistia_responsive_padding">
  <div class="wistia_responsive_wrapper">
    <div id="my_video" [class]="wistiaClass">
      <div class="wistia_swatch">
        <img [src]="source" [alt]="altText" />
      </div>
    </div>
  </div>
</div>
